const cms = 'cms';
const profile = 'profile';

const landingPage = '/';
const AllChallenges = `/${cms}/allChallenges`;
const contest = `/${cms}/contest/:contestId`;
const allContest = `/${cms}/allContests/:id`;
const result = `/${cms}/result/:contestId`;
const candidateInfo = `/${cms}/candidateInfo/:accountId/:contestId`;
const aboutPage = '/about';
const blackFridayPage = '/black-friday';
const contactPage = '/contact';
const membershipPage = '/membership';
const cookiesPage = '/cookies';
const policyPage = '/privacy-policy';
const faqPage = '/faq';
const challengeListPage = '/challenges';
const exerciseListPage = '/exercises';
const courseListPage = '/courses';
const challengeLandingPage = `${challengeListPage}/:id?`;
const exerciseLandingPage = `${exerciseListPage}/:id?`;
const courseLandingPage = `${courseListPage}/:id?`;
const freecodeExercisePage = `/exercise/:exerciseId`;
const freecodeChallengePage = `/challenge/:contestId`;
const freecodeCreatorPage = `/freecode-creator/:testId`;
const freecodeTestTrialPage = `/freecode-test-trial`;
const freecodeTestPage = `/freecode-test/:ticketId`;
const freecodeTestInspectPage = `/freecode-test-inspect/:inputId`;
const freecodeCreatorInspectPage = `/freecode-creator-inspect/:testId`;
const freecodeLiveCodingPage = `/freecode-live-coding/:ticketId`;
const companyPage = '/company';
const companyEventsPage = '/company-events';
const hackathon = '/hackathon/:id';
const hackathonMatches = '/hackathon-matches/:id';
const codeChallenge = '/codechallenge';
const notFoundPage = '/notFound';
const profilePage = `/${profile}`;
const profileChallenges = `/${profile}/challenges`;
const profileExercises = `/${profile}/exercises`;
const profileFriends = `/${profile}/friends`;
const profileCourses = `/${profile}/courses`;
const achievementPage = `/${profile}/achievements`;
const xpPage = `/${profile}/xp`;
const candidateFeedbackPage = '/candidateFeedback';
const statistics = '/statistics';
const loginPage = '/login';
const signupPage = '/signup';
const resetPasswordPage = '/resetpassword';
const setPasswordPage = '/setpassword/:session';
const payments = '/payments';
const subscriptionPlans = '/plans';
const handleStripeResponse = '/checkout/:transactionId/:sessionID/:paymentID/:paymentStatus';
const customTests = '/customTests';
const multichoice = '/multichoice/:ticketId';
const candidateTicketsPage = '/tickets';
const ticketSessionPage = '/session/:session';
const settings = '/settings';
const departmentSettings = '/department-settings/:departmentId';
const superadmin = '/superadmin';
const downloadReport = '/report/:id/:session';
const report = '/report/:id';
const anonymiseReport = '/anonymiseReport/:id';
const codeComparison = '/codeComparison/:ticketId/:anonymised';
const redirect = '/c/:redirectValue';
const questionFeedbackPage = '/questionFeedback';
const unsubscribe = '/unsubscribe/:id';
const testsPage = '/tests';
const defaultHandler = '*';
const sendTestPage = '/send-test';
const communityEmailPage = '/community-email';
const multichoiceCreatorPage = '/multichoice-creator/:testId/:questionId?';
const GDPRDeletionPage = '/GDPR';
const GDPRConfirmationPage = 'GDPR/:session';
const schoolLandingPage = '/school/:pageId/:school?';
const courseStripeResponse = '/course/checkout/:transactionId/:sessionID/:paymentId';

const Path = {
  landingPage,
  AllChallenges,
  contest,
  allContest,
  result,
  candidateInfo,
  aboutPage,
  contactPage,
  membershipPage,
  cookiesPage,
  policyPage,
  faqPage,
  challengeListPage,
  exerciseListPage,
  courseListPage,
  challengeLandingPage,
  exerciseLandingPage,
  courseLandingPage,
  freecodeExercisePage,
  freecodeChallengePage,
  freecodeCreatorPage,
  freecodeTestTrialPage,
  freecodeTestPage,
  freecodeTestInspectPage,
  freecodeCreatorInspectPage,
  freecodeLiveCodingPage,
  companyPage,
  companyEventsPage,
  hackathon,
  hackathonMatches,
  codeChallenge,
  notFoundPage,
  profilePage,
  profileChallenges,
  profileExercises,
  profileFriends,
  profileCourses,
  candidateFeedbackPage,
  statistics,
  achievementPage,
  loginPage,
  signupPage,
  resetPasswordPage,
  setPasswordPage,
  payments,
  subscriptionPlans,
  handleStripeResponse,
  customTests,
  multichoice,
  candidateTicketsPage,
  ticketSessionPage,
  settings,
  departmentSettings,
  superadmin,
  report,
  codeComparison,
  downloadReport,
  anonymiseReport,
  xpPage,
  redirect,
  questionFeedbackPage,
  unsubscribe,
  testsPage,
  defaultHandler,
  sendTestPage,
  communityEmailPage,
  multichoiceCreatorPage,
  GDPRDeletionPage,
  GDPRConfirmationPage,
  blackFridayPage,
  schoolLandingPage,
  courseStripeResponse,
};

export default Path;
